import { render, staticRenderFns } from "./AdminViewsGroup.vue?vue&type=template&id=7e4ffe3e&scoped=true"
import script from "./AdminViewsGroup.vue?vue&type=script&lang=js"
export * from "./AdminViewsGroup.vue?vue&type=script&lang=js"
import style0 from "./AdminViewsGroup.vue?vue&type=style&index=0&id=7e4ffe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4ffe3e",
  null
  
)

export default component.exports